import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-pending-list-skeleton',
  templateUrl: './pending-list-skeleton.component.html',
  styleUrls: ['./pending-list-skeleton.component.scss'],
})
export class PendingListSkeletonComponent implements OnInit {

  slots: number[] = [];
  @Input('count') set count(n: number) {
    if (n <= 0)
      n = 1;

    for(var i = 1; i <= n; i++) {
      this.slots.push(i);
    }
  }

  @Input('hidden') hidden: boolean;
  
  constructor() { 
  }
  
  ngOnInit() {
  }

}
